import { useMemo, useState } from "react";

import { Text } from "../primitives/typography";

import { Select, type SelectProps } from "./selects";

type SearchableSelectProps = Omit<
  SelectProps,
  | "nothingFound"
  | "onSearchChange"
  | "searchValue"
  | "searchable"
  | "filter"
  | "filterDataOnExactSearchMatch"
  | "creatable"
  | "getCreateLabel"
  | "shouldCreate"
  | "onCreate"
> & {
  includeSearchKeyword?: boolean;
  noResultsLabel?: string;
};

/**
 * The existing accounting helper, now a composite over the owned Select contract. It always owns
 * the search, filtering, creation, and empty states; callers retain ordinary field props.
 */
export const SearchableSelect = ({ includeSearchKeyword = true, noResultsLabel = "No Records found", ...props }: SearchableSelectProps) => {
  const [searchKeyword, setSearchKeyword] = useState("");

  const noResultsComponent = useMemo(
    () => (
      <Text>
        {noResultsLabel}
        {includeSearchKeyword && (
          <>
            {" "}
            for &quot;<em>{searchKeyword}</em>&quot;
          </>
        )}
      </Text>
    ),
    [searchKeyword, noResultsLabel, includeSearchKeyword],
  );

  return (
    <Select
      {...props}
      nothingFound={noResultsComponent}
      placeholder={props.placeholder ?? "Select a record"}
      searchable
      searchValue={searchKeyword}
      onSearchChange={setSearchKeyword}
    />
  );
};
